import { render, staticRenderFns } from "./ConfigTabDutyPositions.vue?vue&type=template&id=780aaf6e"
import script from "./ConfigTabDutyPositions.vue?vue&type=script&lang=js"
export * from "./ConfigTabDutyPositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports